import React from 'react';

export default function Footer() {
    return (
        <footer id="footer" className="main-footer">
            <div className="footer-holder">
                <div className="container">
                    <div className="top-row d-flex align-items-center">
                        <a href="#" className="logo">
                            <img src="/images/footer-logo-sm.png" alt="" />
                        </a>
                        <a href="#topAnchor" className="anchor-btn js-scroll">
                            <i className="icon-up-arrow"></i>
                        </a>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="footer-box-wrap">
                                <a className="footer-title" data-bs-toggle="collapse" href="#footerCollapse1" role="button" aria-expanded="false" aria-controls="footerCollapse1">紐約</a>
                                <div className="collapse d-lg-block" id="footerCollapse1">
                                    <ul className="list-unstyled">
                                        <li>
                                            <span className="title">總機</span>
                                            <a href="tel:212-699-3800" className="phone-link">212-699-3800</a
                                            ><a href="mailto:info@nysingtao.com" className="mail-link">info@nysingtao.com</a>
                                        </li>
                                        <li>
                                            <span className="title">廣告部</span>
                                            <a href="tel:212-699-3800" className="phone-link">212-699-3800按106或107</a>
                                            <a href="mailto:sales@nysingtao.com" className="mail-link">sales@nysingtao.com</a>
                                        </li>
                                        <li>
                                            <span className="title">分類廣告</span>
                                            <a href="tel:212-699-3808" className="phone-link">212-699-3808</a>
                                            <a href="mailto:classified@nysingtao.com" className="mail-link">classified@nysingtao.com</a>
                                        </li>
                                        <li>
                                            <span className="title">發⾏部</span>
                                            <a href="tel:212-699-3800" className="phone-link">212-699-3800按162或164</a>
                                            <a href="mailto:cir@nysingtao.com" className="mail-link">cir@nysingtao.com</a>
                                        </li>
                                        <li>
                                            <span className="title">市場推廣部</span>
                                            <a href="tel:212-699-3800" className="phone-link">212-699-3800按111</a>
                                            <a href="mailto:marketing@nysingtao.com" className="mail-link">marketing@nysingtao.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="footer-box-wrap">
                                <a className="footer-title" data-bs-toggle="collapse" href="#footerCollapse2" role="button" aria-expanded="false" aria-controls="footerCollapse2">三藩市</a>
                                <div className="collapse d-lg-block" id="footerCollapse2">
                                    <ul className="list-unstyled">
                                        <li>
                                            <span className="title">總機</span>
                                            <a href="tel:1-800-746-4826" className="phone-link">1-800-746-4826</a>
                                            <a href="mailto:sf@singtaousa.com" className="mail-link">sf@singtaousa.com</a>
                                        </li>
                                        <li>
                                            <span className="title">商業廣告</span>
                                            <a href="tel:650-808-8888" className="phone-link">650-808-8888</a>
                                            <a href="mailto:advertising@singtaousa.com" className="mail-link">advertising@singtaousa.com</a>
                                        </li>
                                        <li>
                                            <span className="title">分類廣告</span>
                                            <a href="tel:650-808-8877" className="phone-link">650-808-8877</a>
                                            <a href="mailto:classified@singtaousa.com" className="mail-link">classified@singtaousa.com</a>
                                        </li>
                                        <li>
                                            <span className="title">訂閱報紙</span>
                                            <a href="tel:650-808-8866" className="phone-link">650-808-8866</a> 或 短信
                                            <a href="sms:650-822-8187" className="phone-link">650-822-8187</a>
                                            <a href="mailto:circulation@singtaousa.com" className="mail-link">circulation@singtaousa.com</a>
                                        </li>
                                        <li>
                                            <span className="title">公司資料</span>
                                            <a href="mailto:feedback@singtao.com" className="mail-link">feedback@singtao.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="footer-box-wrap">
                                <a className="footer-title" data-bs-toggle="collapse" href="#footerCollapse3" role="button" aria-expanded="false" aria-controls="footerCollapse3">洛杉磯</a>
                                <div className="collapse d-lg-block" id="footerCollapse3">
                                    <ul className="list-unstyled">
                                        <li>
                                            <span className="title">總機</span>
                                            <span>Main</span>
                                            <a href="tel:626-956-8200" className="phone-link">(626) 956-8200 (電話)</a> /<br />
                                            <a href="tel:626-956-8208" className="phone-link">(626) 956-8208 (傳真)</a>
                                            <a href="mailto:admin@singtaola.com" className="mail-link">admin@singtaola.com</a>
                                        </li>
                                        <li>
                                            <span className="title">廣告/市場部</span>
                                            <span>Advertising &amp; Marketing</span>
                                            <a href="tel:626-956-8200" className="phone-link">(626) 956-8200 (電話)</a> /
                                            <a href="tel:626-956-8108" className="phone-link">(626) 956-8108 (傳真)</a>
                                            <a href="mailto:marketing@singtaola.com" className="mail-link">marketing@singtaola.com</a>
                                        </li>
                                        <li>
                                            <span className="title">訂閱部</span><span>Circulation Department</span>
                                            <a href="tel:626-956-8227" className="phone-link">(626) 956-8227 (電話)</a> /<br />
                                            <a href="tel:626-239-3323" className="phone-link">(626) 239-3323 (傳真)</a>
                                            <a href="mailto:circulation@singtaola.com" className="mail-link">circulation@singtaola.com</a>
                                        </li>
                                        <li>
                                            <span className="title">會計部</span><span>Accounting Department</span>
                                            <a href="mailto:accounting@singtaola.com" className="mail-link">accounting@singtaola.com</a>
                                        </li>
                                        <li>
                                            <span className="title">新聞採訪部</span>
                                            <span>News Department</span>
                                            <a href="mailto:reporter@singtaola.com" className="mail-link">reporter@singtaola.com</a>
                                        </li>
                                        <li>
                                            <span className="title">編輯部</span>
                                            <span>Editorial Department</span>
                                            <a href="mailto:editor@singtaola.com" className="mail-link">editor@singtaola.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright-row">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="copyright-holder d-block d-lg-flex">
                                <p>© Copyright {new Date().getFullYear()} Sing Tao Ltd. All rights reserved.</p>
                                <ul className="footer-nav list-unstyled d-flex">
                                    <li><a href="https://www.singtaousa.com/ny/page-ny-privacy/">私隱政策聲明</a></li>
                                    <li><a href="https://www.singtaousa.com/ny/page-ny-terms/">使⽤條款</a></li>
                                    <li><a href="https://www.singtaousa.com/ny/page-ny-copyright/">版權告⽰</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12 d-none d-lg-flex col-lg-4 ml-lg-auto justify-content-end">
                            <ul className="list-unstyled d-none d-md-flex social-list ml-lg-auto">
                                <li><a href="#"><i className="icon-instagram"></i></a></li>
                                <li><a href="#"><i className="icon-twitter"></i></a></li>
                                <li><a href="#"><i className="icon-facebook"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
